/**
 * The Important star. Personal: this is MY bookmark on the task, so the
 * filled state comes from task.isImportant, which the API computes per user.
 */

interface StarButtonProps {
  active: boolean;
  busy?: boolean;
  onToggle: () => void;
}

export function StarButton({ active, busy, onToggle }: StarButtonProps) {
  return (
    <button
      type="button"
      disabled={busy}
      onClick={(event) => {
        // Rows may become clickable later; the star must never trigger that.
        event.stopPropagation();
        onToggle();
      }}
      aria-pressed={active}
      aria-label={active ? 'Remove from Important' : 'Mark as Important'}
      title={active ? 'Remove from Important' : 'Mark as Important'}
      className={[
        'grid h-7 w-7 shrink-0 place-items-center rounded-full transition disabled:opacity-50',
        active
          ? 'text-amber-500 hover:bg-amber-50'
          : 'text-slate-300 hover:bg-slate-100 hover:text-slate-400',
      ].join(' ')}
    >
      <svg viewBox="0 0 20 20" aria-hidden="true" className="h-4.5 w-4.5"
           fill={active ? 'currentColor' : 'none'}>
        <path
          d="M10 3l2.2 4.5 5 .7-3.6 3.5.85 5L10 14.3 5.55 16.7l.85-5L2.8 8.2l5-.7L10 3z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
